const CHAT_LIMITS = {
  MAX_FILES: 10,
  MAX_FILE_SIZE_MB: 5,
  MAX_MESSAGE_LENGTH: 1000,
} as const;

export const CHAT_THEME = {
  COLORS: {
    CUSTOMER: {
      PRIMARY: "green.500",
      SECONDARY: "green.50",
      HOVER: "green.100",
      BORDER: "green.200",
      TEXT: "green.700",
      TEXT_UNREAD: "white",
    },
    SUPPLIER: {
      PRIMARY: "blue.500",
      SECONDARY: "blue.50",
      HOVER: "blue.100",
      BORDER: "blue.200",
      TEXT: "blue.700",
      TEXT_UNREAD: "white",
    },
  },
  SIZES: {
    INBOX_WIDTH: "270px",
    CHAT_WIDTH: "400px",
    CHAT_HEIGHT: "600px",
    INBOX_HEIGHT: "560px",
  },
  POSITIONS: {
    INBOX_OFFSET: "0%",
    CHAT_OFFSET: "calc(280px + .5%)",
  },
  ANIMATIONS: {
    DURATION: 0.3,
    EASING: "easeInOut",
  },
  LIMITS: {
    ...CHAT_LIMITS,
    MAX_FILE_SIZE_BYTES: CHAT_LIMITS.MAX_FILE_SIZE_MB * 1024 * 1024,
  },
} as const;

export const CHAT_CONTENT = {
  CUSTOMER: {
    TITLE: "Customers",
    ICON: "👤",
    LABEL: "Customer",
    SEARCH_PLACEHOLDER: "Enter Order No. or Name",
    EMPTY_MESSAGE: "No customer chats available",
  },
  SUPPLIER: {
    TITLE: "Suppliers",
    ICON: "🏪",
    LABEL: "Supplier",
    SEARCH_PLACEHOLDER: "Enter Order No. or Name",
    EMPTY_MESSAGE: "No supplier chats available",
  },
} as const;
